import { render, staticRenderFns } from "./defaultFileView.vue?vue&type=template&id=7d4ae453&scoped=true&lang=pug"
import script from "./defaultFileView.vue?vue&type=script&lang=js"
export * from "./defaultFileView.vue?vue&type=script&lang=js"
import style0 from "./defaultFileView.vue?vue&type=style&index=0&id=7d4ae453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ae453",
  null
  
)

export default component.exports